import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  Box,
  Modal,
  ModalContext,
  Text,
  toast,
  useServerResponseTranslation,
} from 'dash-ui';
import {
  CurrentBrokerHasAlertConfigsDocument,
  GetAlertConfigsDocument,
  useRemoveAlertConfigMutation,
} from 'gql/generated.graphql';

const RemoveAlertModal = () => {
  const theme = useTheme();
  const { t } = useTranslation(['common']);
  const { isOpenCurrent, toggleModal, setPayload, payload } =
    useContext(ModalContext);
  const isOpen = !!isOpenCurrent['RemoveAlertModal'];
  const { alertConfigId, paginationState } = payload || {};
  const translateErrorMessage = useServerResponseTranslation();
  const [removeAlertConfigMutation, { loading }] =
    useRemoveAlertConfigMutation();

  const onModalClose = useCallback(() => {
    toggleModal(false, 'RemoveAlertModal');
    setPayload(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRemoveButtonClick = useCallback(
    (e: { stopPropagation: () => void }) => {
      e.stopPropagation();
      removeAlertConfigMutation({
        variables: {
          alertConfigId: alertConfigId,
        },
        refetchQueries: [
          CurrentBrokerHasAlertConfigsDocument,
          {
            query: GetAlertConfigsDocument,
            variables: {
              pagination: {
                limit:
                  paginationState.perPage * (paginationState.currentPage + 1),
              },
            },
            fetchPolicy: 'network-only',
          },
        ],
        onCompleted: onModalClose,
        onError: (error) => {
          toast.error(translateErrorMessage(error));
        },
      });
    },
    [
      alertConfigId,
      paginationState,
      removeAlertConfigMutation,
      onModalClose,
      translateErrorMessage,
    ]
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onModalClose}
      title={t('pages:alertPage:labels:deleteAlertModalTitle') || ''}
      cancelButton={{ title: t('common:labels.cancel'), onClick: onModalClose }}
      submitButton={{
        title: t('common:labels.delete'),
        isLoading: loading,
        disabled: loading,
        colorVariation: 'danger',
        // @ts-ignore
        onClick: onRemoveButtonClick,
      }}
    >
      <Box py={3}>
        <Text color={theme.colors.n80}>
          {t('pages:alertPage:labels:deleteAlertModalSubTitle') || ''}
        </Text>
      </Box>
    </Modal>
  );
};

export default RemoveAlertModal;
